import React, { useContext } from "react";
import { TabList, Tab } from "@fluentui/react-tabs";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import { ACTIONS, BORDER, TABS } from "../../constants/Constants";
import { t } from "i18next";
import NextPreviousSection from "./NextPreviousSection";
import CustomBreadCrumb from "../CustomBreadCrumb";
import themeContext from "../../context/theme/ThemeContext";

const DesktopTabView = (props) => {
  const { getThemeColor,themeName,getAlterColor } = useContext(themeContext);
  const leftPanelWidth =
    props.leftPanelWidth != null && props.leftPanelWidth != undefined
      ? props.leftPanelWidth
      : 30;
  const rightPanelWidth =
    props.leftPanelWidth != null && props.leftPanelWidth != undefined
      ? 100 - props.leftPanelWidth
      : 70;
  const customHeight = props.customHeight != null && props.customHeight != undefined ? props.customHeight : "calc(100% - 40px)"

  const checkForButtonPresent = () => {
    if (
      props.topButtons?.length > 0 ||
      ((props.routerState === ACTIONS.ADD ||
        props.routerState === ACTIONS.EDIT) &&
        (props.onCancelClick != undefined || props.onSubmitClick != undefined))
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      {props.breadCrumbItems.length > 0 && (
        <div
          className="breadCrumb"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <CustomBreadCrumb items={props.breadCrumbItems} />
          {props.headerTopButtons != null && props.headerTopButtons != undefined && props.headerTopButtons?.length > 0 && (
            <div className="top-section-button" style={{marginRight: "10px"}}>
              {props?.headerTopButtons?.map((ele, index) => {
                return ele.button;
              })}
            </div>
          )}
        </div>
      )}
      {/* {props.routerState === ACTIONS.VIEW && (
              <PrimaryButton
                style={{ marginLeft: "10px" }}
                text="Edit"
                onClick={props.onEditClick}
              />
            )} */}

      <div
        style={{
          display: "flex",
          // height: props.topButtons?.length > 0 ? "84%" : "92%",
          height: customHeight,
          borderTop: getThemeColor("border"),
          boxSizing: "border-box",
        }}
      >
        <div className="left-side-cmp" style={{ width: `${leftPanelWidth}%` }}>
          <TabList
            style={
              {
                // borderBottom:
                //   props.routerState != ACTIONS.VIEW
                //     ? "1px solid #3D3D3D"
                //     : "none",
              }
            }
            className="left-side-tablist-cmp modal-scroll"
            selectedValue={props.selectedValue}
            onTabSelect={props.onTabSelect}
            vertical
          >
            {props.tabDetails.map((tabElement, index) => {
              return (
                <Tab
                  key={index}
                  className={`tab-container-cmp ${
                    index % 2 != 0
                      ? "tab-alternative-color"
                      : "tab-second-alternative-color"
                  }
              }`}
                  id={`${props.uniqueKey}${(index + 1).toString()}`}
                  value={`${props.uniqueKey}${(index + 1).toString()}`}
                  style={{justifyContent:"unset"}}
                >
                  {tabElement.tabKeyContain}
                </Tab>
              );
            })}
          </TabList>
          <div
            className="left-side-button-container"
            style={{
              borderTop: checkForButtonPresent() ? getThemeColor("border") : "unset",
            }}
          >
            {props.topButtons?.length > 0 && (
              <div className="top-section-button">
                {props?.topButtons?.map((ele, index) => {
                  return ele.button;
                })}
              </div>
            )}
            {props.routerState == null ||
              ((props.routerState === ACTIONS.ADD ||
                props.routerState === ACTIONS.EDIT) &&
                props.onCancelClick != undefined && (
                  <DefaultButton
                    style={{ marginLeft: "10px" }}
                    text={t("button.cancel")}
                    onClick={props.onCancelClick}
                  />
                ))}
            {props.routerState == null ||
              ((props.routerState === ACTIONS.ADD ||
                props.routerState === ACTIONS.EDIT) &&
                props.onSubmitClick != undefined && (
                  <PrimaryButton
                    style={{ marginLeft: "10px" }}
                    text={t("button.save")}
                    onClick={props.onSubmitClick}
                  />
                ))}
          </div>
        </div>

        <div
          className="modal-scroll details-container-cmp"
          style={{ width: `${rightPanelWidth}%` }}
        >
        <div style={{
          background: themeName === "light"?TABS.LIGHT_GLOBAL_GRAY:"unset",
          padding:"10px",
          height: props.previousNextButton ? "92%" : "100%",
          boxSizing: "border-box",
          borderBottom: props.previousNextButton ? getThemeColor("border"): "unset",
          }}>
        <div
            style={{
              boxSizing: "border-box",
              background: themeName === "light"?"#FFF":"unset",
              borderRadius: themeName === "light"?"10px":"unset",
              border: themeName === "light"?`1px solid ${getAlterColor("unset","#b7b7b7")}`:"unset",
              height:"100%"
            }}
          >
             {props.tabDetails.map((tabElement, index) => {
              return (
                props.uniqueKey + tabElement.selectedKey ==
                  props.selectedValue && (
                  <div
                    key={index}
                    className="modal-scroll"
                    style={{
                      height: "100%",
                      overflow: "auto",
                    }}
                  >
                    {tabElement.tabValueContain}
                  </div>
                )
              );
            })}
          </div>
        </div>
          {props.previousNextButton && (
            <div className="next-previos-section-cmp">
              <NextPreviousSection
                isMobile={props.isMobile}
                prevDisabled={
                  parseInt(props.getNumberFromString(props.selectedValue)) == 1
                    ? true
                    : false
                }
                nextDisabled={
                  props.NoOfTabs ==
                  parseInt(props.getNumberFromString(props.selectedValue))
                    ? true
                    : false
                }
                handleNextClick={props.handleNextClick}
                handlePreviousClick={props.handlePreviousClick}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DesktopTabView;
